<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Select } from '@Shelly/shelly-design-system';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
	import type { TargetSelectOption } from 'src/helpers/actions/local/core/target_local_options';
	import type { Device } from 'src/types/Device';

	export let controlOption: LocalControlOptions;
	export let selectedDeviceId: Device['id'] = null;
	export let onChange: (deviceId?: Device['id'], componentId?: number) => void = () => {};

	const changeTarget = (option: unknown) => {
		if (typeof option !== 'object' || option === null) return;

		const { componentId, value } = option as TargetSelectOption;
		const selectedComponentId = componentId ?? value;
		if (typeof selectedComponentId !== 'number') return;

		controlOption.params.id = selectedComponentId;
		onChange(componentId != null ? String(value) : undefined, selectedComponentId);
	};

	const getSelectedTarget = () =>
		(controlOption.attr.target as TargetSelectOption[]).find(({ componentId, value }) =>
			componentId != null && selectedDeviceId
				? value === selectedDeviceId
				: (componentId ?? value) == controlOption.params.id,
		);
</script>

<div>
	<Text class="mb-s" element="h2">
		{$format('select_target_component', {
			default: 'Select target component:',
		})}
	</Text>
	<Select
		size="m"
		value={getSelectedTarget() ||
			$format('non_existed_component', {
				default: 'Non-Existed Component',
			})}
		options={controlOption.attr.target}
		disabled={controlOption.attr.target.length <= 1}
		icon={'fal fa-microchip'}
		on:change={(e) => changeTarget(e.detail)}
		id="select-jli8pqj"
		aria-label={$format('select_target_component', {
			default: 'Select target component',
		})}
	/>
</div>
